var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaults(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2511",
    "data-name": "Rectangle 2511",
    width: 24,
    height: 24,
    transform: "translate(19 208)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4746",
    "data-name": "Mask Group 4746",
    transform: "translate(-19 -208)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Box",
    transform: "translate(1.836 175.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7641",
    "data-name": "Group 7641",
    transform: "translate(20 36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8233",
    "data-name": "Path 8233",
    d: "M36.777,40.66H21.553A1.553,1.553,0,0,1,20,39.107,3.107,3.107,0,0,1,23.107,36H35.223a3.107,3.107,0,0,1,3.107,3.107A1.553,1.553,0,0,1,36.777,40.66Z",
    transform: "translate(-20 -36)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8234",
    "data-name": "Path 8234",
    d: "M75.223,159.107v6.214a3.107,3.107,0,0,1-3.107,3.107h-9.01A3.107,3.107,0,0,1,60,165.32V156",
    transform: "translate(-58.447 -151.34)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8235",
    "data-name": "Path 8235",
    d: "M184.35,239.107h-2.8a1.553,1.553,0,0,1,0-3.107h2.8a1.553,1.553,0,0,1,0,3.107Z",
    transform: "translate(-153.786 -192.233)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaults);
export default __webpack_public_path__ + "static/media/defaults.69b89b92010c632eac8dd735ba0b8f61.svg";
export { ForwardRef as ReactComponent };